import React, { Component } from 'react';
import { Row, Col, Select } from 'antd';
import { urlapi, token, CheckTokenExp } from '../../config';

class StatusSMS extends Component {
    constructor(props) {
        super(props);

        this.RequestSMSStatus = this.RequestSMSStatus.bind(this);
        this.onChangeSelect = this.onChangeSelect.bind(this);

        this.state = {
            statussms: "",
            smslist: [],
        }
    }

    componentDidMount() {
        setTimeout(() => {
            this.RequestSMSStatus()
        }, 10)
    }

    RequestSMSStatus() {
        if (!CheckTokenExp()) {
            fetch(urlapi + "api/smsstatus", {
                method: 'get',
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "Authorization": "Bearer " + token
                },
            }).then(
                function (data) {
                    if (data.ok) {
                        data.json().then(
                            function (json) {
                                this.setState({
                                    smslist: json
                                });
                            }.bind(this)
                        );
                    }
                }.bind(this)
            ).catch(function () {
                Modal.error({
                    content: 'Error on the internal server',
                });
            }.bind(this));
        } else {
            this.props.history.push("/logout");
        }
    }

    onChangeSelect(value, e) {
        this.setState({ [e.props.name]: value });
        this.props.onchange(value)
    }

    render() {
        const Option = Select.Option
        const _sms = this.state.smslist
        return (
            <Select
                showSearch
                style={{ width: '100%' }}
                placeholder="SMS Status"
                optionFilterProp="children"
                onChange={this.onChangeSelect}
                value={this.state.statussms}
                filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
            >
                <Option name="statussms" value="">SMS Status</Option>
                {_sms.map((c, index) => (
                    <Option key={index} name="statussms" value={c.smS_ID}>
                        {c.smS_NAME}
                    </Option>
                ))}
            </Select>
        );
    }
}

export default StatusSMS;



// WEBPACK FOOTER //
// ./src/views/Dropdown/StatusSMS.js